/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Footnote_EmbeddingInputs */

const en_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** Embedding 608/708 Closed Captioning in video available on Pro plan only.`)
};

const fr_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** L'intégration de sous-titres 608/708 dans la vidéo est disponible uniquement sur le forfait Pro.`)
};

const de_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** Die Einbettung von 608/708 Untertiteln in Videos ist nur im Pro-Tarif verfügbar.`)
};

const it_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** L'inserimento dei sottotitoli 608/708 nel video è disponibile solo con il piano Pro.`)
};

const ru_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** Встраивание субтитров 608/708 в видео доступно только в тарифном плане Pro.`)
};

const es_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** La incorporación de subtítulos 608/708 en videos está disponible solo en el plan Pro.`)
};

const zh_cn2_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** 仅在专业版计划中提供在视频中嵌入 608/708 隐藏式字幕的功能。`)
};

const ja_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** ビデオへの 608/708 クローズド キャプションの埋め込みは Pro プランでのみ利用可能です。`)
};

const hi_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** वीडियो में 608/708 क्लोज्ड कैप्शनिंग एम्बेड करने की सुविधा केवल प्रो प्लान में उपलब्ध है।`)
};

const pt_pt2_signup_footnote_embedding = /** @type {(inputs: Signup_Footnote_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**** A incorporação de legendas ocultas 608/708 em vídeos está disponível apenas no plano Pro.`)
};

/**
* | output |
* | --- |
* | "**** Embedding 608/708 Closed Captioning in video available on Pro plan only." |
*
* @param {Signup_Footnote_EmbeddingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_footnote_embedding = /** @type {((inputs?: Signup_Footnote_EmbeddingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Footnote_EmbeddingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_footnote_embedding(inputs)
	if (locale === "de") return de_signup_footnote_embedding(inputs)
	if (locale === "it") return it_signup_footnote_embedding(inputs)
	if (locale === "ru") return ru_signup_footnote_embedding(inputs)
	if (locale === "es") return es_signup_footnote_embedding(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_footnote_embedding(inputs)
	if (locale === "ja") return ja_signup_footnote_embedding(inputs)
	if (locale === "hi") return hi_signup_footnote_embedding(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_footnote_embedding(inputs)
	return en_signup_footnote_embedding(inputs)
});